import dayjs from 'dayjs';
import formatDate from './formatDate';

/**
 * Читаемое описание применённых фильтров — для строки «что сейчас отфильтровано»
 * над таблицей. Значения берём из тех же объектов опций, из которых собирается
 * запрос (HookForm кладёт выбранное в item.value), чтобы подпись не разъезжалась
 * с тем, что реально ушло на бэк.
 */
const asText = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'object') {
    // Селект отдаёт { value, label }, датапикер — дату.
    if (value.label !== undefined && value.label !== null) return String(value.label);
    return dayjs(value).isValid() ? formatDate(value) : null;
  }
  return String(value);
};

const describeFilters = (options = []) =>
  options
    .map((option) => ({
      name: option.name,
      label: option.label || option.title || option.name,
      text: asText(option.value),
    }))
    .filter((item) => item.text);

export default describeFilters;
